import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const MuiDialog: {
    styleOverrides: ComponentsOverrides<Theme>['MuiDialog'];
    defaultProps?: ComponentsProps['MuiDialog'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            [theme.breakpoints.down('sm')]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        }),
        paper: ({ theme }) => ({
            [theme.breakpoints.down('sm')]: {
                margin: 0,
            },
        }),
        paperWidthSm: () => ({
            width: '600px',
        }),
        paperWidthLg: {
            width: '1280px',
        },
    },
    defaultProps: {
        maxWidth: 'sm',
    },
};

export const MuiDialogContent: {
    styleOverrides: ComponentsOverrides<Theme>['MuiDialogContent'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            [theme.breakpoints.down('sm')]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        }),
    },
};

export const MuiDialogActions: {
    styleOverrides: ComponentsOverrides<Theme>['MuiDialogActions'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            [theme.breakpoints.down('sm')]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        }),
    },
};

export const MuiDialogTitle: {
    styleOverrides: ComponentsOverrides<Theme>['MuiDialogTitle'];
    defaultProps?: ComponentsProps['MuiDialogTitle'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            padding: theme.spacing(3.75, 0),
            textAlign: 'center',
            height: theme.spacing(12),
        }),
    },
    defaultProps: {
        variant: 'h4',
        component: 'h4',
    },
};
